import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-calyrafit-gird-image';

const html = `
<div
  data-use-custom-width="false"
  data-custom-width="1204"
  class="container marquee-group"
  data-attribute="container-content"
  style="--custom-width: 1204px;"
>
  <div class="block-grid">
    <a href="#" class="wrap-main-image" data-attribute="wrap-main-image">
      <img data-attribute="image-main" src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f3268537b5d44d4accc8.png" alt="">
    </a>
    <div data-attribute="group-img-second" class="group-img-second">
      <a href="" class="wrap-img-item" data-attribute="wrap-img-item">
        <img data-attribute="image-second" src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f329504baa57b33c01c7.png" alt="">
      </a>
      <a href="" class="wrap-img-item" data-attribute="wrap-img-item">
        <img data-attribute="image-second" src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f32c053c8005bdcd3547.png" alt="">
      </a>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css);
